export default __webpack_public_path__ + "static/media/notes.14a44178.svg";